import { IconChevronRight } from "@tabler/icons-react";
import { useRef } from "react";

export function InspirationMediaCard({
  title,
  thumbnailSrc,
  previewVideoSrc,
  onClick,
}: {
  title: string;
  thumbnailSrc: string;
  previewVideoSrc?: string;
  onClick: () => void;
}) {
  const videoRef = useRef<HTMLVideoElement>(null);

  const handleActivate = () => {
    if (!previewVideoSrc || !videoRef.current) return;
    videoRef.current.currentTime = 0;
    // play() returns a promise that rejects if interrupted by pause();
    // swallow that expected AbortError.
    void videoRef.current.play().catch(() => {});
  };

  const handleDeactivate = () => {
    if (!previewVideoSrc || !videoRef.current) return;
    videoRef.current.pause();
    videoRef.current.currentTime = 0;
  };

  return (
    <button
      type="button"
      className="group relative aspect-square w-full cursor-pointer overflow-hidden rounded-[8px] border border-[#333333] bg-text-primary focus-visible:outline-2"
      onClick={onClick}
      onMouseEnter={handleActivate}
      onMouseLeave={handleDeactivate}
      onFocus={handleActivate}
      onBlur={handleDeactivate}
    >
      {previewVideoSrc ? (
        <video
          ref={videoRef}
          poster={thumbnailSrc}
          preload="none"
          src={previewVideoSrc}
          muted
          loop
          playsInline
          className="absolute inset-0 size-full object-cover"
        />
      ) : (
        <img
          className="absolute inset-0 size-full object-cover"
          src={thumbnailSrc}
          alt=""
        />
      )}

      <div className="absolute inset-0 bg-linear-to-t from-black/60 via-black/10 to-transparent opacity-100 transition-opacity duration-300 group-hover:opacity-0 group-focus:opacity-0" />

      <div className="absolute right-0 bottom-2.5 left-0 flex flex-row items-center justify-between gap-0.5 pr-2 pl-3.5 text-left leading-0 xl:bottom-3 xl:pl-4">
        <span className="flex-1 text-sm leading-5 font-semibold text-white xl:text-base">
          {title}
        </span>
        <IconChevronRight className="text-white/80" size={16} stroke={1.5} />
      </div>
    </button>
  );
}
